import { addressTypes } from '../types';

const initialState = {
    loading: true,
    list: null,
    error: null,
    item: null,
};

export const address = (state = initialState, action) => {
    switch (action.type) {
        case addressTypes.LIST_REQUEST:
            return {
                ...state,
                loading: true,
                item: null,
            };

        case addressTypes.LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.list,
            };
        case addressTypes.LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case addressTypes.ADDRESS_LOAD_REQUEST:
            return {
                ...state,
                loading: true,
                item: null,
            };
        case addressTypes.ADDRESS_LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                item: action.item,
            };
        case addressTypes.ADDRESS_LOAD_ERROR:
            return {
                ...state,
                loading: false,
                item: null,
                error: action.error,
            };

        case addressTypes.ADDRESS_SAVE_REQUEST:
            return {
                ...state,
                loading: true,
                item: action.item,
            };
        case addressTypes.ADDRESS_SAVE_SUCCESS:
            return {
                ...state,
                loading: false,
                item: null,
            };
        case addressTypes.ADDRESS_SAVE_ERROR:
            return {
                ...state,
                loading: false,
                item: null,
                error: action.error,
            };

        case addressTypes.ADDRESS_NEW_ADD_REQUEST:
            return {
                ...state,
                loading: true,
                item: action.item,
            };
        case addressTypes.ADDRESS_NEW_ADD_LOADED:
            return {
                ...state,
                loading: false,
            };
        case addressTypes.ADDRESS_NEW_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                item: null,
            };
        case addressTypes.ADDRESS_NEW_ADD_ERROR:
            return {
                ...state,
                loading: true,
                item: null,
                error: action.error,
            };

        case addressTypes.ADDRESS_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
                id: action.id,
            };
        case addressTypes.ADDRESS_DELETE_SUCCESS:
            return {
                ...state,
                loading: true,
                id: null,
            };
        case addressTypes.ADDRESS_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                id: null,
                error: action.error,
            };

        default:
            return state;
    }
};
